import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const userFeedbackMenuRegistry = {
    crm_userFeedback: {
        label: "User Feedback",
        link: PAGE_URL.USER_FEEDBACK_PAGE,
        key: PAGE_URL.USER_FEEDBACK_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default userFeedbackMenuRegistry;
